import '../../style/store/store product/SP_Description.css';
import { FaPlay } from "react-icons/fa";



const SP_Description =({descriptin,video,video_cover})=>{

  const play_video=()=>{
    document.querySelector(".sp-description-p3-2-video-cover-container").style.display="none";
    let vid = document.querySelector(".sp-description-p3-2-video");
    vid.play();
  }
  return(
    <div className="sp-description">
      <div className="sp-description-title">شرح آزمون</div>
      <div className="sp-description-p1">
        <div className="sp-description-p1-title">این آزمون به درد چه کسانی می خورد؟</div>
        <div className="sp-description-p1-content">{descriptin[1]}</div>
      </div>
      <div className="sp-description-p2">
        <div className="sp-description-p2-title">آیا افراد عادی هم می‌توانند در این آزمون شرکت کنند؟</div>
        <div className="sp-description-p2-content">{descriptin[1]}</div>
      </div>
      <div className="sp-description-p3">
        <div className="sp-description-p3-1">
          <div className="sp-description-p3-1-title">راهنمای شرکت در آزمون</div>
          <div className="sp-description-p3-1-content">{descriptin[2]}</div>
        </div>
        <div className="sp-description-p3-2">
          <div className="sp-description-p3-2-video-cover-container">
            <img className="sp-description-p3-2-video-cover" src={video_cover} alt="video-cover" />
            <div className="sp-description-p3-2-video-play-btn" onClick={play_video}>
              <FaPlay className="sp-description-p3-2-video-play-btn-icon" />
            </div>
          </div>
          <video className="sp-description-p3-2-video" width="383" height="214" controls>
            <source src={video} />
          </video>
        </div>
      </div>
    </div>
  )
}

export default SP_Description;